import React, { useRef } from "react";

/**
 * Modal backdrop that only dismisses when the click both BEGINS and ENDS on
 * the backdrop itself. This fixes the long-standing bug where dragging a text
 * selection from inside the modal to outside (mouseup on backdrop) closed the
 * modal mid-selection.
 *
 * Drop-in replacement for:
 *    <div className="fixed inset-0 ..." onClick={onClose}>...</div>
 *
 * Usage:
 *    <ModalBackdrop onClose={onClose}>
 *      <div className="..." onClick={(e) => e.stopPropagation()}>
 *        ...modal content...
 *      </div>
 *    </ModalBackdrop>
 */
export default function ModalBackdrop({ onClose, children, className = "fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm", testId }) {
    const downOnBackdrop = useRef(false);
    const onMouseDown = (e) => { downOnBackdrop.current = e.target === e.currentTarget; };
    const onMouseUp = (e) => {
        if (downOnBackdrop.current && e.target === e.currentTarget) onClose?.();
        downOnBackdrop.current = false;
    };
    return (
        <div className={className} onMouseDown={onMouseDown} onMouseUp={onMouseUp} data-testid={testId}>
            {children}
        </div>
    );
}
